import { subscribeToThreads } from '@tiptap-pro/extension-comments';
import type { TCollabThread, TiptapCollabProvider } from '@tiptap-pro/provider';
import { useEffect, useState } from 'react';

interface ThreadsState {
  threads: TCollabThread[];
  loaded: boolean;
}

export function useThreads(provider: TiptapCollabProvider | null): ThreadsState {
  const [state, setState] = useState<ThreadsState>({ threads: [], loaded: false });

  useEffect(() => {
    if (!provider) {
      setState({ threads: [], loaded: false });
      return;
    }

    const unsubscribe = subscribeToThreads({
      provider,
      callback: (currentThreads) => setState({ threads: currentThreads, loaded: true }),
    });

    return () => unsubscribe();
  }, [provider]);

  return state;
}
